var EmitterPro = (function () {
    function EmitterPro() {
        this.handlers = {};
    }
    EmitterPro.prototype.eventNames = function () {
        var _a;
        var symbols = ((_a = Object.getOwnPropertySymbols) === null || _a === void 0 ? void 0 : _a.call(Object, this.handlers)) || [];
        var keys = Object.keys(this.handlers);
        return keys.concat(symbols);
    };
    EmitterPro.prototype.rawListeners = function (eventName) {
        var handler = this.handlers[eventName];
        return handler ? handler.map(function (item) { return item.raw; }) : [];
    };
    EmitterPro.prototype.listeners = function (eventName) {
        var handler = this.handlers[eventName];
        return handler ? handler.map(function (item) { return item.wrap; }) : [];
    };
    EmitterPro.prototype.hasListener = function (eventName, listener) {
        return this.rawListeners(eventName).some(function (item) { return item === listener; });
    };
    EmitterPro.prototype._on = function (eventName, raw, wrap, context, dir) {
        if (context === void 0) { context = null; }
        if (dir === void 0) { dir = 1; }
        var currentListener = { raw: raw, wrap: wrap, context: context };
        if (!this.handlers[eventName]) {
            this.handlers[eventName] = [currentListener];
        }
        else {
            var appendMethod = dir === 1 ? 'push' : 'unshift';
            this.handlers[eventName][appendMethod](currentListener);
        }
        return this;
    };
    EmitterPro.prototype.prependListener = function (eventName, listener, context) {
        return this._on(eventName, listener, listener, context, 0);
    };
    EmitterPro.prototype.on = function (eventName, listener, context) {
        return this._on(eventName, listener, listener, context);
    };
    EmitterPro.prototype._wrapOnce = function (eventName, listener, context) {
        var _this = this;
        if (context === void 0) { context = null; }
        var wrap = (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            listener.apply(context, args);
            _this.off(eventName, wrap);
        });
        return wrap;
    };
    EmitterPro.prototype.once = function (eventName, listener, context) {
        var wrap = this._wrapOnce(eventName, listener, context);
        return this._on(eventName, listener, wrap, context);
    };
    EmitterPro.prototype.prependOnceListener = function (eventName, listener, context) {
        var wrap = this._wrapOnce(eventName, listener, context);
        return this._on(eventName, listener, wrap, context, 0);
    };
    EmitterPro.prototype.off = function (eventName, listener) {
        var handler = this.handlers[eventName];
        if (handler) {
            if (listener) {
                var index = handler.findIndex(function (item) { return item.wrap === listener || item.raw === listener; });
                if (index !== -1) {
                    handler.splice(index, 1);
                }
            }
            else {
                delete this.handlers[eventName];
            }
        }
        return this;
    };
    EmitterPro.prototype.offAll = function () {
        this.handlers = {};
        return this;
    };
    EmitterPro.prototype.emit = function (eventName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var handler = this.handlers[eventName];
        if (handler && handler.length > 0) {
            handler.forEach(function (listener) {
                listener.wrap.apply(listener.context, args);
            });
            return true;
        }
        return false;
    };
    return EmitterPro;
}());

export { EmitterPro as default };
